import { useCallback } from 'react';
import { Button } from 'semantic-ui-react';
import { pendingOrdersToCsv } from 'modules/pending-orders-to-csv/pending-orders-to-csv';
import FileSaver from 'file-saver';

export default function DownloadCSVButton({ pendingOrders }) {
  const downloadCSV = useCallback(() => {
    const blob = new Blob([pendingOrdersToCsv(pendingOrders)], {
      type: 'text/csv;charset=utf-8',
    });
    FileSaver.saveAs(blob, `pending-orders_${Date.now()}.csv`);
  }, [pendingOrders]);

  return (
    <Button
      basic
      content="Descargar CSV"
      disabled={Boolean(!pendingOrders?.length)}
      onClick={downloadCSV}
    />
  );
}
